"use client";
import React, { useState } from "react";
import ComponentCard from "../../common/ComponentCard"; 
import Label from "../Label";
import TextArea from "../input/TextArea";

export default function TextAreaInput() {
  const [message, setMessage] = useState("");
  const [messageTwo, setMessageTwo] = useState("");
  
  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
  };
  
  const handleMessageTwoChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessageTwo(e.target.value);
  };

  return (
    <ComponentCard title="Textarea input field">
      <div className="space-y-6">
        {/* Default TextArea */}
        <div>
          <Label>Description</Label>
          <TextArea
            value={message}
            onChange={handleMessageChange}
            rows={6}
          />
        </div>

        {/* Disabled TextArea */}
        <div>
          <Label>Description</Label>
          <TextArea 
            rows={6} 
            disabled 
            placeholder="This textarea is disabled"
          />
        </div>

        {/* Error TextArea */}
        <div>
          <Label>Description</Label>
          <TextArea
            rows={6}
            value={messageTwo}
            error="This field is required" // Pass error message as string
            onChange={handleMessageTwoChange}
            hint="Please enter a valid message."
          />
        </div>

        {/* ReadOnly TextArea */}
        <div>
          <Label>Description (Read Only)</Label>
          <TextArea
            rows={4}
            value="This text is read-only and cannot be edited."
            readOnly
          />
        </div>
      </div>
    </ComponentCard>
  );
}